<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M1082 1062 l-132 -89 50 -27 50 -27 -17 -30 c-10 -17 -46 -67 -79
-112 -261 -347 -551 -549 -836 -583 l-58 -7 0 -34 0 -35 63 7 c327 38 670 286
941 683 27 40 54 72 60 72 6 0 31 -11 55 -25 23 -14 45 -25 47 -25 2 0 4 72 4
160 0 88 -3 160 -7 160 -5 0 -68 -40 -141 -88z"
      />
      <path
        d="M395 858 c-52 -19 -83 -47 -101 -93 -36 -96 1 -173 127 -261 44 -31
90 -69 101 -85 l21 -28 51 41 c28 23 55 45 60 50 14 11 -28 53 -111 109 -82
56 -111 98 -94 135 8 18 19 24 45 24 39 0 53 -13 58 -55 3 -30 4 -30 72 -33
42 -2 72 1 76 8 11 18 -6 99 -27 128 -33 46 -98 72 -178 71 -38 0 -83 -5 -100
-11z"
      />
      <path
        d="M57 853 c-4 -3 -7 -150 -7 -325 0 -290 1 -318 17 -318 9 0 45 5 80
11 l63 11 0 314 0 314 -73 0 c-41 0 -77 -3 -80 -7z"
      />
      <path
        d="M777 853 c-4 -3 -7 -63 -7 -132 l1 -126 45 50 c41 46 140 173 158
203 6 9 -15 12 -92 12 -54 0 -102 -3 -105 -7z"
      />
      <path
        d="M1086 800 c-20 -28 -36 -52 -36 -55 0 -11 87 -4 98 7 18 18 15 85 -4
92 -9 3 -17 6 -19 6 -2 0 -19 -23 -39 -50z"
      />
      <path
        d="M853 511 l-83 -89 0 -99 c0 -64 4 -103 12 -111 15 -15 134 -16 143
-2 4 6 7 68 8 138 l2 127 85 5 85 5 0 55 0 55 -85 2 -85 2 -82 -88z"
      />
      <path
        d="M287 413 c-11 -11 -8 -90 5 -118 14 -31 20 -31 88 3 54 27 55 27 51
67 -1 22 -5 43 -8 48 -5 9 -127 10 -136 0z"
      />
      <path
        d="M656 330 c-27 -21 -82 -58 -123 -82 -40 -23 -73 -47 -73 -52 0 -10
71 -2 131 14 49 14 96 61 109 112 6 22 10 41 8 43 -2 1 -25 -14 -52 -35z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
